import { TableStyleTypes } from "./EditTableviewSidebar";
import Input from "../FormComponents/Input";
import React from "react";

const EditTableForPositioned = ({ editElementData, setEditElementData }) => {
  const { options } = editElementData;
  const { show_border, show_header, table_style } = options;

  // Handle the change for border visibility
  const handleFunction = (e) => {
    setEditElementData({
      ...editElementData,
      options: {
        ...editElementData.options,
        [e.target.name]: e.target.checked
      }
    });
  };
  // Handle changes for table style (type)
  const handleTableTypeFunction = (value) => {
    setEditElementData({
      ...editElementData,
      options: {
        ...editElementData.options,
        table_style: value
      }
    });
  };

  return (
    <>
      <TableStyleTypes type={table_style || ""} onChange={handleTableTypeFunction} />
      <Input type="checkbox" label="Table Border" checked={show_border} name="show_border" onChange={handleFunction} />
      <Input type="checkbox" label="Table Header" checked={show_header} name="show_header" onChange={handleFunction} />
    </>
  );
};

export default EditTableForPositioned;
